export const setHidpiBackgroundImage = ($element, imageUrl, imageUrl2x) => {
    $element.attr('style', [
        `background-image: url(${imageUrl})`,
        `background-image: -webkit-image-set(url(${imageUrl}) 1x, url(${imageUrl2x}) 2x)`,
        `background-image: image-set(url(${imageUrl}) 1x, url(${imageUrl2x}) 2x)`,
    ].join(';'));
};
